import React from 'react';

// RENTOS brand: the wordmark whose O is a three-quarter ring, and the
// receipt mark that carries the same ring. Colours follow the surrounding
// text (currentColor) so the logo sits on any theme; the ring is always
// the brand orange.
export const RING = '#f28c28';

export const BrandRing = ({ size = 32, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" className={className} aria-hidden="true">
    <circle cx="50" cy="50" r="36" fill="none" stroke="currentColor" strokeOpacity=".25" strokeWidth="18" />
    <path d="M50 14 A36 36 0 1 1 14 50" fill="none" stroke={RING} strokeWidth="18" strokeLinecap="round" />
  </svg>
);

// `tile`: on a dark rounded square (the app icon), so the white receipt
// also reads on light backgrounds.
export const BrandMark = ({ size = 48, tile = false, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 120 120" className={className} aria-hidden="true">
    {tile && <rect width="120" height="120" rx="26" fill="#15171b" />}
    <g transform={tile ? 'translate(12 12) scale(.8)' : undefined}>
      <path d="M28 10 H92 V96 L84 104 L76 96 L68 104 L60 96 L52 104 L44 96 L36 104 L28 96 Z" fill="#fff" />
      <circle cx="60" cy="52" r="22" fill="none" stroke="#15171b" strokeOpacity=".18" strokeWidth="11" />
      <path d="M60 30 A22 22 0 1 1 38 52" fill="none" stroke={RING} strokeWidth="11" strokeLinecap="round" />
      <rect x="44" y="82" width="32" height="6" rx="3" fill="#15171b" fillOpacity=".35" />
    </g>
  </svg>
);

// "RENT◯S": the ring sits in the O's place at the cap height of the text.
export const BrandWordmark = ({ size = 28, className = '', style }) => (
  <span className={`brand-word ${className}`} style={{ fontSize: size, ...style }} aria-label="RENTOS" data-testid="brand-wordmark">
    RENT<BrandRing size={size * 1.02} className="brand-word-ring" />S
  </span>
);

export const BrandLockup = ({ size = 28, mark = true, className = '' }) => (
  <span className={`brand-lockup ${className}`}>
    {mark && <BrandMark size={size * 1.9} />}
    <BrandWordmark size={size} />
  </span>
);
